import React from "react";
import Alert from "react-bootstrap/Alert";

export const ErrorAlert = ({ heading, text }) => {
  return (
    <div
      style={{ position: "absolute", top: 0, left: 0, right: 0, zIndex: 999 }}
    >
      <Alert variant="danger" dismissible>
        <Alert.Heading>{heading}</Alert.Heading>
        <p>{text}</p>
      </Alert>
    </div>
  );
};
